import { site } from '../../site';
import { PageTitle } from '../PageTitle';

const FAQS = [
  {
    q: 'Where does Dala work?',
    a: `The pilot is ${site.region}, ${site.country}. Bookings outside that area are not available yet.`,
  },
  {
    q: 'How do I pay?',
    a: 'Cash when the rider or order arrives. The pilot does not take cards or in-app wallets.',
  },
  {
    q: 'How do I become a driver or merchant?',
    a: 'Open the app, go to your account tab, and apply. We review papers before you can go online or list a store.',
  },
  {
    q: 'How do I delete my account?',
    a: `Email ${site.supportEmail} from the number or email on the account, or message Dala support in the app, and ask us to delete it.`,
  },
] as const;

export function SupportPage() {
  return (
    <div className="bg-paper text-ink">
      <PageTitle>Support — dala</PageTitle>
      <div className="mx-auto max-w-3xl px-5 py-14 md:px-8 md:py-20">
        <p className="overline">Help</p>
        <h1 className="mt-3 text-4xl leading-tight md:text-5xl">
          Help & support
        </h1>
        <p className="mt-4 max-w-xl text-[15px] font-medium leading-relaxed text-ink/60">
          Something stuck on a trip, an order, or your account? Start in the
          app. If you cannot, email us.
        </p>

        <div className="mt-10 grid gap-4">
          <article className="card p-6">
            <p className="overline">Fastest</p>
            <h2 className="mt-2 text-xl">In the app</h2>
            <p className="mt-2 text-[14px] font-medium leading-relaxed text-ink/60">
              Open Dala → Chat → Dala support. Tell us your name, the trip or
              order, and what went wrong. Support reads Bisaya, Tagalog, and
              English.
            </p>
          </article>
          <article className="card p-6">
            <p className="overline">Email</p>
            <h2 className="mt-2 text-xl">
              <a
                href={`mailto:${site.supportEmail}?subject=Dala%20support`}
                className="hover:underline"
              >
                {site.supportEmail}
              </a>
            </h2>
            <p className="mt-2 text-[14px] font-medium leading-relaxed text-ink/60">
              Include the phone number on the account and, if you have one, the
              ride or order reference. We reply during Philippine business hours.
            </p>
          </article>
        </div>

        <div className="mt-14">
          <p className="overline">Common questions</p>
          <div className="mt-5 divide-y divide-ink/10">
            {FAQS.map((item) => (
              <div key={item.q} className="py-5">
                <h2 className="text-lg">{item.q}</h2>
                <p className="mt-2 text-[14px] font-medium leading-relaxed text-ink/60">
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-10 text-[13px] font-semibold text-ink/45">
          {site.operator} · {site.region}, {site.country}
        </p>
      </div>
    </div>
  );
}
